export type AppOrientation = 'portrait-primary' | 'portrait-secondary' | 'landscape-primary' | 'landscape-secondary';

export function readScreenOrientation(browser: Window | undefined): AppOrientation {
    if (!browser) return 'portrait-primary';
    const modern = browser.screen?.orientation?.type;
    if (modern) return modern;
    const angle = browser.orientation;
    if (typeof angle === 'number') {
        if (Math.abs(angle) === 90) return 'landscape-primary';
        return angle === 180 ? 'portrait-secondary' : 'portrait-primary';
    }
    const landscape = browser.matchMedia?.('(orientation: landscape)').matches
        ?? browser.innerWidth > browser.innerHeight;
    return landscape ? 'landscape-primary' : 'portrait-primary';
}
